{
  "containerLevel": [
    {
      "label": "containerId",
      "displayLabel": "Container Id",
      "editable": false,
      "hidden": true
    },
    {
      "label": "chargeId",
      "displayLabel": "Charge Id",
      "editable": false,
      "hidden": true
    },
    {
      "label": "containerNumber",
      "displayLabel": "Container Number",
      "placeholder": "Enter Container Number",
      "editable": false,
      "isPinned": true,
      "fieldInfo": {
        "dataType": "select",
        "options": [
          {
            "label": "IGM Item Number",
            "value": "IGM_ITEM_NUMBER"
          }
        ]
      }
    },
    {
      "label": "chargeName",
      "displayLabel": "Charge Name",
      "placeholder": "Select Charge",
      "editable": false,
      "isPinned": false,
      "hasLookup": true,
      "fieldInfo": {
        "dataType": "picklist",
        "disable": false,
        "lookupDetails": {
          "apiUrl": "v1/charges/list",
          "selectFields": [
            "id",
            "name",
            "code"
          ],
          "filterByKeys": [
            "name",
            "code"
          ],
          "limit": 10,
          "orderBy": {
            "name": "asc"
          },
          "filterByKey": "name",
          "bindLabel": "name",
          "bindValue": "id",
          "displayColumns": [
            {
              "key": "name",
              "header": "Name"
            },
            {
              "key": "code",
              "header": "Code"
            }
          ]
        }
      }
    },
    {
      "label": "hsnOrSacCode",
      "displayLabel": "HSN Or SAC Code",
      "editable": false,
      "display": true
    },
    {
      "label": "chargeCode",
      "displayLabel": "Charge Code",
      "editable": false,
      "display": true
    },
    {
      "label": "description",
      "displayLabel": "Description",
      "placeholder": "Enter Description",
      "editable": true,
      "display": true,
      "fieldInfo": {
        "disable": false,
        "dataType": "text",
        "style": {
          "width": "300px"
        }
      }
    },
    {
      "label": "amount",
      "displayLabel": "Charge Amount",
      "placeholder": "Enter Charge Amount",
      "editable": true,
      "display": true,
      "fieldInfo": {
        "disable": false,
        "dataType": "text"
      }
    }
  ],
  "invoiceLevel": [
    {
      "label": "chargeId",
      "displayLabel": "Charge Id",
      "editable": false,
      "hidden": true
    },
    {
      "label": "name",
      "displayLabel": "Charge",
      "placeholder": "Select Charge",
      "editable": false,
      "isPinned": true,
      "hasLookup": true,
      "fieldInfo": {
        "dataType": "picklist",
        "disable": false,
        "lookupDetails": {
          "apiUrl": "v1/charges/list",
          "selectFields": [
            "id",
            "name",
            "code"
          ],
          "filterByKeys": [
            "name",
            "code"
          ],
          "limit": 10,
          "orderBy": {
            "name": "asc"
          },
          "filterByKey": "name",
          "bindLabel": "name",
          "bindValue": "id",
          "displayColumns": [
            {
              "key": "name",
              "header": "Name"
            },
            {
              "key": "code",
              "header": "Code"
            }
          ]
        }
      }
    },
    {
      "label": "hsnOrSacCode",
      "displayLabel": "HSN Or SAC Code",
      "editable": false,
      "display": true
    },
    {
      "label": "chargeCode",
      "displayLabel": "Charge Code",
      "editable": false,
      "display": true
    },
    {
      "label": "description",
      "displayLabel": "Description",
      "placeholder": "Enter Description",
      "editable": true,
      "display": true,
      "fieldInfo": {
        "disable": false,
        "dataType": "text",
        "style": {
          "width": "300px"
        }
      }
    },
    {
      "label": "amount",
      "displayLabel": "Charge Amount",
      "placeholder": "Enter Charge Amount",
      "editable": true,
      "display": true,
      "fieldInfo": {
        "disable": false,
        "dataType": "text"
      }
    }
  ]
}
